import {isETicketRoute} from '../config/config';

/**
 * Shared geometry for the floating buttons anchored to the bottom corner
 * (AI agent FAB, support bubble) so they can offset around each other.
 */
export const AI_AGENT_FAB_SIZE_PX = 64;

/**
 * Feature-level gate. The per-user check is runtime — see useIsAiAgentFabRendered.
 * isETicketRoute (not isETicketDomain) because the digital ticket is also served from
 * /n/:token on the app domain, and the agent must never appear there.
 */
export const IS_AI_AGENT_FAB_ENABLED = !isETicketRoute;

/** Bottom-corner offset for a button sitting beside the AI agent FAB. */
export const FLOATING_BUTTON_INLINE_END_BESIDE_FAB =
    `calc(var(--space-lg) + ${AI_AGENT_FAB_SIZE_PX}px + var(--space-xl))`;

/** Bottom-corner offset when nothing else shares the corner. */
export const FLOATING_BUTTON_INLINE_END_ALONE = '19px';
